import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Field } from "./Login";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("Reset your password")} sub={t("We will email you a link to choose a new password.")}>
      {done ? (
        <div className="rounded-xl border border-line bg-surface p-5 text-sm" data-testid="forgot-done">
          <p className="font-bold text-good">{t("Check your inbox")}</p>
          <p className="mt-1 text-muted">{t("If that email exists, a reset link is on its way. It expires in 1 hour.")}</p>
          <Link to="/login" className="mt-4 inline-block font-bold text-accent">{t("Back to login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field id="email" label={t("Email")} type="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="forgot-email" placeholder="you@example.com" />
          {error && <p className="rounded-lg bg-bad/10 px-3 py-2 text-sm text-bad" data-testid="forgot-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="forgot-submit"
            className="w-full rounded-xl bg-accent px-4 py-3 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? t("Sending…") : t("Send reset link")}
          </button>
          <p className="text-sm text-muted"><Link to="/login" className="font-bold text-accent">{t("Back to login")}</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
